import { ListCheck } from '@pzh-ui/icons'

import {
    useGetRevisionsProgrammaAlgemeenVersion,
    useProgrammaAlgemeenEditObjectStatic,
    useProgrammaAlgemeenGetListActiveModuleObjects,
    useProgrammaAlgemeenListValidLineages,
    useProgrammaAlgemeenListValidLineageTree,
    useProgrammaAlgemeenPostModulePatchObject,
    useProgrammaAlgemeenViewGetObjectStatic,
    useProgrammaAlgemeenViewModuleObjectLatest,
    useProgrammaAlgemeenViewObjectLatest,
    useProgrammaAlgemeenViewObjectVersion,
} from '@/api/fetchers'
import { generateDynamicSchema } from '@/validation/dynamicObject'
import { schemaDefaults } from '@/validation/zodSchema'

import { DynamicObject } from './types'

const fetchers = {
    useGetValid: useProgrammaAlgemeenListValidLineages,
    useGetValidLineage: useProgrammaAlgemeenListValidLineageTree,
    useGetVersion: useProgrammaAlgemeenViewObjectVersion,
    useGetLatestLineage: useProgrammaAlgemeenViewObjectLatest,
    useGetRevision: useGetRevisionsProgrammaAlgemeenVersion,
    useGetRelations: null,
    usePutRelations: null,
    useGetLatestLineageInModule: useProgrammaAlgemeenViewModuleObjectLatest,
    usePatchObjectInModule: useProgrammaAlgemeenPostModulePatchObject,
    usePatchObject: null,
    useDeleteObject: null,
    useGetStatic: useProgrammaAlgemeenViewGetObjectStatic,
    usePostStatic: useProgrammaAlgemeenEditObjectStatic,
    useGetAcknowledgedRelations: null,
    usePostAcknowledgedRelations: null,
    usePatchAcknowledgedRelations: null,
    usePostObject: null,
    useGetActiveModules: useProgrammaAlgemeenGetListActiveModuleObjects,
}

const programmaAlgemeen: DynamicObject<typeof fetchers> = {
    defaults: {
        singular: 'programma_algemeen',
        singularReadable: 'programma algemeen',
        singularCapitalize: 'Programma algemeen',
        plural: 'programmas-algemeen',
        pluralReadable: "programma's algemeen",
        pluralCapitalize: "Programma's algemeen",
        prefixSingular: 'het',
        prefixPlural: 'de',
        prefixNewObject: 'Nieuw',
        demonstrative: 'dit',
        slugOverview: 'omgevingsprogramma',
        icon: ListCheck,
        hideBreadcrumbs: true,
        parentType: 'Programma',
    },
    staticData: ['Owner_1_UUID', 'Owner_2_UUID'],
    fetchers,
    dynamicSections: [
        {
            fields: [
                {
                    name: 'Title',
                    label: 'Titel',
                    description:
                        'Formuleer in enkele woorden de titel van het programma algemeen.',
                    type: 'text',
                    required: true,
                    validation: schemaDefaults.title,
                },
                {
                    name: 'Description',
                    label: 'Inhoud',
                    description:
                        'Een goede beleidstekst is kort, krachtig en actief opgeschreven. Zo weet de lezer direct wat de provincie gaat doen en waarom dit van belang is. Schrijf altijd ‘de provincie’, en niet ‘wij’.',
                    type: 'wysiwyg',
                    required: true,
                    hasAreaSelect: true,
                    customMenuOptions: [
                        'heading',
                        'image',
                        'subscript',
                        'superscript',
                        'table',
                    ],
                    imageOptions: {
                        options: {
                            allowBase64: true,
                            inline: true,
                        },
                        uploadOptions: {
                            maxSize: 819200,
                        },
                    },
                },
            ],
        },
    ],
}

programmaAlgemeen.validationSchema = generateDynamicSchema(
    programmaAlgemeen.dynamicSections
)

export default programmaAlgemeen
